module.exports = __webpack_public_path__ + "static/media/John F. Kerry - 2004.6b48e319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John F. Kerry - 2004.jpg
// module id = 520
// module chunks = 0